import { Box, Stack, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

/**
 * Calm zero-state for an empty list / table / search result.
 *
 * Props:
 *  - icon:        ReactNode (defaults to InboxOutlined)
 *  - title:       string
 *  - description: string | ReactNode
 *  - action:      ReactNode (button / link)
 *  - dense:       reduce vertical padding (useful inside cards)
 */
export default function EmptyState({
  icon,
  title,
  description,
  action,
  dense = false,
  sx,
}) {
  const Icon = icon ?? <InboxOutlinedIcon sx={{ fontSize: 36 }} />;
  return (
    <Stack
      spacing={1.5}
      alignItems="center"
      textAlign="center"
      sx={{
        py: dense ? { xs: 4, sm: 5 } : { xs: 6, sm: 8 },
        px: 3,
        color: "text.secondary",
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          bgcolor: "background.default",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.tertiary",
        }}
      >
        {Icon}
      </Box>
      {title && (
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="body2" sx={{ maxWidth: 360 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ pt: 0.5 }}>{action}</Box>}
    </Stack>
  );
}
